import React from 'react';
import { Skeleton, Typography } from 'antd';
import { DotChartOutlined } from '@ant-design/icons';

type Props = {
  label: string;
  value?: string;
  children?: React.ReactNode;
  valueFontSize?: number;
  loading?: boolean;
  boldLabel?: boolean;
  valueUnit?: string;
};
const { Text } = Typography;
const DetailItem: React.FC<Props> = ({
  label,
  value,
  children,
  valueFontSize,
  loading,
  boldLabel,
  valueUnit,
}) => {
  return (
    <div style={{ margin: '10px 0px' }}>
      <Text
        style={{
          display: 'block',
          marginBottom: 3,
          fontSize: 12,
          fontWeight: boldLabel ? 600 : 400,
          color: '#768499',
        }}
      >
        {label}
      </Text>
      {loading ? (
        <Skeleton.Node active style={{ width: 120, height: 20 }}>
          &nbsp;
        </Skeleton.Node>
      ) : value ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Text
            style={{
              lineHeight: '100%',
              fontSize: valueFontSize || 14,
              fontWeight: valueFontSize ? 600 : 400,
            }}
          >
            {value}
          </Text>
          {valueUnit && (
            <Text
              style={{
                fontSize: 12,
                color: '#768499',
              }}
            >
              {valueUnit}
            </Text>
          )}
        </div>
      ) : !children ? (
        <Text
          style={{
            display: 'block',
            lineHeight: '100%',
            color: '#8C8C8C',
            fontSize: valueFontSize || 14,
            fontWeight: valueFontSize ? 600 : 400,
          }}
        >
          Not Set
        </Text>
      ) : (
        <React.Fragment></React.Fragment>
      )}
      {!loading && children}
    </div>
  );
};
export default DetailItem;
